import { isDefined } from '@automator/utilities';
import { fadeIn, fadeOut } from '@automator/animations';

/**
 * Handles the functionality of the banner that requests reviews
 */
export default class ReviewBanner {
    constructor() {
        if ( this.hasBanner ) {
            // Listen first step
            this.listenFirstStep();

            // Listen the buttons that close the banners
            this.listenCloseButtons();
        }
    }

    /**
     * Listens the buttons defined on the first step
     */
    listenFirstStep() {
        this.$firstStepButtons.positive.addEventListener( 'click', () => {
            // Wait 150ms to improve UX
            // That way things won't happen too fast and the user will have time to process what's happening
            setTimeout( () => {
                // Show the "positive" banner
                fadeIn( this.$secondStepBanners.positive );
            }, 150 );
        } );

        this.$firstStepButtons.negative.addEventListener( 'click', () => {
            // Wait 150ms to improve UX
            // That way things won't happen too fast and the user will have time to process what's happening
            setTimeout( () => {
                // Show the "negative" banner
                fadeIn( this.$secondStepBanners.negative );
            }, 150 );
        } );
    }

    /**
     * Listens the buttons that close the banners
     */
    listenCloseButtons() {
        // Do the same for all the three banners
        [ this.$banner, ...Object.values( this.$secondStepBanners ) ].forEach( ( $banner ) => {
            // Find the buttons
            $banner.querySelectorAll( '[data-action="hide-banner-on-click"]' ).forEach( ( $button ) => {
                // Listen clicks to the button
                $button.addEventListener( 'click', () => {
                    // Hide the closest banner
                    fadeOut( $button.closest( '.notice' ) );
                } );
            } );
        } );
    }

    /**
     * Returns the banners displayed in the second step
     * 
     * @returns {Object} Object of Nodes
     */
    get $secondStepBanners() {
        return {
            positive: document.getElementById( 'uap-review-banner-positive' ),
            negative: document.getElementById( 'uap-review-banner-negative' ),
        }
    }

    /**
     * Returns the buttons that defines the next step
     * 
     * @returns {Object} Object of Nodes
     */
    get $firstStepButtons() {
        return {
            positive: document.getElementById( 'uap-review-banner-btn-positive' ),
            negative: document.getElementById( 'uap-review-banner-btn-negative' ),
        }
    }

    /**
     * Checks whether the page contains the review banner
     * 
     * @returns {Boolean} True if the banner exists on the page
     */
    get hasBanner() {
        return isDefined( this.$banner );
    }

    /**
     * Returns the review banner
     * 
     * @returns {Node} The banner
     */
    get $banner() {
        return document.getElementById( 'uap-review-banner' );
    }
}
